import type { EditorTabKind } from './editorWorkspaceIds';

const ICON_BY_KIND: Record<EditorTabKind, string> = {
  text: 'doc',
  code: 'variable',
  markdown: 'textdocument',
  drawio: 'image',
  document: 'doc',
  spreadsheet: 'xlsxfile',
  pdf: 'pdffile',
  media: 'photo'
};

export function editorTabKindIcon(kind: EditorTabKind, mediaKind?: 'image' | 'video'): string {
  if (kind === 'media' && mediaKind === 'video') return 'video';
  return ICON_BY_KIND[kind];
}

export function confirmCloseDirtyTabs(
  tabs: { dirty?: boolean; title: string }[],
  message: string
): boolean {
  if (!tabs.some((tab) => tab.dirty)) return true;
  return window.confirm(message);
}
